import React from 'react';

import { useParams } from 'react-router-dom';

import Tab, { TabGroup } from '@amzn/meridian/tab';
import { useQuery } from '@tanstack/react-query';
import { getAccommodationQueryOptions } from 'src/services/accommodation/accommodationQueries';
import { useAppSelector } from 'src/store/store';

interface TopTabsProps {
  selectedTab: string;
  setSelectedTab: (val: string) => void;
}
const TopTabs = ({ selectedTab, setSelectedTab }: TopTabsProps) => {
  const { placementId } = useParams();
  const { data: placementDetails } = useQuery(getAccommodationQueryOptions.accommodationDetails(+placementId!));
  const { featureFlags } = useAppSelector((state) => state.user);

  return (
    <TabGroup value={selectedTab} onChange={(selectedTab) => setSelectedTab(selectedTab)}>
      <Tab value="placement-selections" data-cy="placement-details__placement-tab">
        Placement Selection(s)
      </Tab>
      <Tab value="restrictions" data-cy="placement-details__restriction-tab">
        Restrictions
      </Tab>
      {!featureFlags.PERSONA && (
        <Tab value="employee-information" data-cy="placement-details__home-process-tab">
          Employee Information
        </Tab>
      )}
      {placementDetails?.accommodationType === 'AUSTIN' && placementDetails?.site?.participatingInDecisionHubPilot && (
        <Tab value="correspondence" data-cy="placement-details__correspondence-tab">
          Correspondence
        </Tab>
      )}
      <Tab value="revision-history" data-cy="placement-details__revision-tab">
        Revision History
      </Tab>
    </TabGroup>
  );
};

export default TopTabs;
